import { t } from 'i18next';

export enum ThresholdRule {
  RSA = 1,
  SYMMETRIC = 2,
  EC = 3,
  CERT_VALIDITY = 64,
  STALE_KEY_202 = 202,
  STALE_KEY_203 = 203,
}

export const ALL_THRESHOLD_RULES = [
  ThresholdRule.RSA,
  ThresholdRule.SYMMETRIC,
  ThresholdRule.EC,
  ThresholdRule.CERT_VALIDITY,
  ThresholdRule.STALE_KEY_202,
  ThresholdRule.STALE_KEY_203,
];

export const CERT_EXPIRING_RULE = 63;
export const DEFAULT_CERT_EXPIRING = 14;

export type ThresholdUnit = 'bits' | 'days';

export type ThresholdInfo = {
  unit: ThresholdUnit;
  getDescription: () => string;
  defaultValues: number[];
};

type ThresholdInfoMapType = {
  [key in ThresholdRule]: ThresholdInfo;
};

export const DEFAULT_EC = [1024, 2048, 3072];
export const DEFAULT_SYMMETRIC = [128, 128, 256];
export const DEFAULT_RSA = [1024, 2048, 3072];
export const DEFAULT_CERT_VALIDITY = [365 * 5, 365 * 7, 365 * 10];
export const DEFAULT_STALE_KEY = [365 * 2, 365 * 3, 365 * 5];

// static well known information about each threshold
export const ThresholdInfoMap: ThresholdInfoMapType = {
  [ThresholdRule.RSA]: {
    unit: 'bits',
    getDescription: () => t('createProfile.rsaDescription') as string,
    defaultValues: [1024, 2048, 3072],
  },
  [ThresholdRule.SYMMETRIC]: {
    unit: 'bits',
    getDescription: () => t('createProfile.symmetricDescription') as string,
    defaultValues: [128, 128, 256],
  },
  [ThresholdRule.EC]: {
    unit: 'bits',
    getDescription: () => t('createProfile.ecDescription') as string,
    defaultValues: [160, 256, 512],
  },
  [ThresholdRule.CERT_VALIDITY]: {
    unit: 'days',
    getDescription: () => t('createProfile.certificateDescription') as string,
    defaultValues: [365 * 5, 365 * 7, 365 * 10],
  },
  [ThresholdRule.STALE_KEY_202]: {
    unit: 'days',
    getDescription: () => t('createProfile.staleDescription') as string,
    defaultValues: [365 * 2, 365 * 3, 365 * 5],
  },
  [ThresholdRule.STALE_KEY_203]: {
    unit: 'days',
    getDescription: () => t('createProfile.staleDescription') as string,
    defaultValues: [365 * 2, 365 * 3, 365 * 5],
  },
};
